import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Cloud Folder illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-cloud-folder',
    styleUrl: 'cloud-folder.css',
    shadow: true,
})
export class EsIllustrationCloudFolder {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 2106.7 2247.2"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <defs>
                    <linearGradient
                        id="cloud_folder_b"
                        x1="2325.23"
                        x2="1993.41"
                        y1="-877.78"
                        y2="-1314.59"
                        gradientTransform="translate(-492 1802.4)"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset="0" stop-color="#bbdefb" />
                        <stop offset="1" stop-color="#fff" />
                    </linearGradient>
                    <linearGradient
                        id="cloud_folder_c"
                        x1="2526.37"
                        x2="2178.89"
                        y1="-295.05"
                        y2="-752.47"
                        href="#cloud_folder_b"
                    />
                    <linearGradient
                        id="cloud_folder_d"
                        x1="1884.99"
                        x2="1501.04"
                        y1="-1257.33"
                        y2="-1762.77"
                        href="#cloud_folder_b"
                    />
                    <clipPath id="cloud_folder_a">
                        <path
                            fill="none"
                            d="m1743.4 1116.6-590.6-341-196.9-310.5-492.2-284.2C382.1 133.8 316 161.8 316 243.3v885.9c0 81.6-16.9 233.8 64.7 280.9l1149.5 663.7 31.8 93.7s10.5 40.5 15 40 66 19 66 19l21.3-12.3 7.7 6.3 162-94-.9-.2c33.9-23.3 57.9-55.1 57.9-87.7v-689.1c0-81.6-66.1-185.8-147.6-232.9z"
                        />
                    </clipPath>
                </defs>
                <path
                    d="m1743.4 1116.6-590.6-341-196.9-310.5-492.2-284.2C382.1 133.8 316 161.8 316 243.3v885.9c0 81.6-16.9 233.8 64.7 280.9l1149.5 663.7 31.8 93.7s10.5 40.5 15 40 66 19 66 19l21.3-12.3 7.7 6.3 162-94-.9-.2c33.9-23.3 57.9-55.1 57.9-87.7v-689.1c0-81.6-66.1-185.8-147.6-232.9z"
                    class="cloud_folder_b"
                />
                <g clip-path="url(#cloud_folder_a)">
                    <path
                        d="M270.7 100.5h442.7v464H270.7z"
                        class="cloud_folder_d"
                    />
                </g>
                <path
                    d="M2099.6 1352.4c0-155.4-97.5-341.7-227-446.1 9.1-21.8 14.1-48.2 14.1-78.6 0-133.1-95.3-296.2-212.6-364.2-43.9-25.4-84.6-33.8-118.1-27.6-61.3-156.3-176-303.4-307.2-379.3-106.8-61.8-202.4-63.7-267.3-17L799 144.8l97 71.3a353 353 0 0 0-1.7 37.1c0 6.7.3 13.9.5 20.6-124.3-22.2-213.1 60.4-213.1 217.9 0 199.8 142.7 444.5 319.2 546.5l770.6 446.1 48.2 160.5 201.6-115.4c48.4-30 78.3-90.8 78.3-177z"
                    class="cloud_folder_d"
                />
                <path
                    fill="url(#cloud_folder_b)"
                    fill-rule="evenodd"
                    d="m1676.5 1018.8 196.6-114.4-.5-.5c9.1-21.8 14.1-48.2 14.1-78.6 0-133.1-95.3-296.2-212.6-364.2-43.9-25.4-84.6-33.8-118.1-27.8-.2-.2-.2-.7-.5-.9l-196.3 114.7z"
                />
                <path
                    fill="url(#cloud_folder_c)"
                    fill-rule="evenodd"
                    d="m1819.7 1642.2 201.6-115.5c48.4-29.7 78.3-90.5 78.3-176.7 0-155.2-97.2-341.2-226.5-445.6L1608 1058.8l143.2 411.2 20.3 11.7z"
                />
                <path
                    fill="url(#cloud_folder_d)"
                    fill-rule="evenodd"
                    d="M1555.8 433.1c-61.3-156.4-175.8-303.2-307-379.1C1142-7.8 1046.4-9.7 981.5 37L799 142.1l97 71.4a353 353 0 0 0-1.7 37.1c0 4.1 0 8.1.3 12.2l331.9 354.7z"
                />
                <path
                    d="M1674.1 1021.5c9.1-21.8 14.1-48.2 14.1-78.6 0-133.1-95.3-296.2-212.7-364.2-43.5-25.4-84.5-33.8-118-27.6-61.3-156.1-176-303.4-307.3-379.3-195.6-113.5-354.6-25.4-354.6 196.6 0 6.7.2 13.9.5 20.6-124.3-22.3-213.2 60.4-213.2 217.9 0 199.7 142.8 444.5 319.2 546.5l815.4 472c156.7 90.8 283.6 20.4 283.6-157.1-.5-156.1-98-342.2-227-446.8z"
                    class="cloud_folder_h"
                />
                <path
                    d="M1203.7 299.7a30.7 30.7 0 0 1 1.7-3.1c-47.4-52.9-99.6-97.5-153.5-128.4-60.6-34.9-118.8-51.7-170.7-50 0 2.8-.3 5.7-.3 8.4 50.6-2 107.3 14.6 166.7 49 53.4 30.9 105.4 75 152.1 127.4a11.6 11.6 0 0 1 4-3.3zm150.9 256 3.4-.5c34-6.2 73.7 3.1 115.1 27.1 26.1 15.3 51.3 35.2 74.5 58.6a10 10 0 0 1 6.5-5.2c-24-24.2-49.6-44.8-76.6-60.4-41.7-24.2-82.2-34-117.4-28.7a818.4 818.4 0 0 0-54.8-112.1 12.4 12.4 0 0 1-7 4.6 834.5 834.5 0 0 1 55.3 113.7zm518.5 1025.9a23.5 23.5 0 0 1 4.3 1.9 7.7 7.7 0 0 1 3.6 1.2c15.8-31.9 23.9-71.4 23.9-116.6 0-152.8-94.8-340.3-226.1-447.6 8.7-22.3 13.2-48.1 13.2-77.4 0-47.4-12.2-98.6-32.5-147.9a18 18 0 0 1-8.2 1.9c20.6 48.6 32.3 99.1 32.3 145.8 0 29.2-4.8 55.3-13.9 77.1l-1.1 2.9 2.6 1.9c130.7 105.4 225.3 291.9 225.3 443 0 44.3-8.1 82.9-23.4 113.8zm-79.8 71.3c-49.1 16.3-109.9 5.8-174.1-31.6l-815.4-472C629 1048.3 487 805 487 606.4c0-80.4 24.2-145.3 68.5-182.2 27.5-23 62.3-35 101.3-35a205.3 205.3 0 0 1 38.3 3.6l5 1-.2-5.3c-.2-6.7-.5-13.4-.5-20.6 0-104.1 35.2-182.2 99.2-219.1a131.5 131.5 0 0 1 12.9-6.7 11.1 11.1 0 0 1-.3-8.4c0-.2.3-.4.3-.9a163.8 163.8 0 0 0-17.3 8.6C727.4 180 690.8 260.2 690.8 367.9c0 5.1 0 10.6.2 15.6-55.5-8.6-104.1 3.1-141.7 34-46.7 39-71.6 104.2-71.6 188.7 0 200.9 144.1 447.6 321.1 550.1l815.4 472c46.2 26.8 90.8 40.2 131 40.2a182.9 182.9 0 0 0 36.1-3.8 83.7 83.7 0 0 1 12-11.8z"
                    class="cloud_folder_i"
                />
                <path
                    fill="none"
                    stroke="#1a4e85"
                    stroke-miterlimit="10"
                    stroke-width="14.17"
                    d="M2099.6 1352.4c0-155.4-97.5-341.7-227-446.1 9.1-21.8 14.1-48.2 14.1-78.6 0-133.1-95.3-296.2-212.6-364.2-43.9-25.4-84.6-33.8-118.1-27.6-61.3-156.3-176-303.4-307.2-379.3-106.8-61.8-202.4-63.7-267.3-17L801 143.6c-65.2 35.2-105.4 113-105.4 224.8 0 6.7.2 13.9.5 20.6-124.3-22.3-213.2 60.4-213.2 217.9 0 199.7 142.8 444.5 319.2 546.5l815.4 472c87.5 50.5 165.3 51 217.2 11l186.8-107c48.2-30 78.1-90.8 78.1-177z"
                />
                <path
                    d="m1678.4 2149.9-96.4-55.6v-575.8c0-5.1-.3-10.3-.8-15.5s-.9-7.9-1.5-11.9c-.2-1.3-.4-2.7-.7-4-12-65.8-59.1-139.1-118.5-184l-7.3-5.4c-2.4-1.8-4.9-3.4-7.4-5.1s-7.5-4.8-11.4-7l-590.6-341-196.9-310.5-492.2-284.2C73.1 302.8 7 330.8 7 412.3v885.9c0 17.5 14.3 30.5 37.6 40.7l-.6 1.6 1552 896-2.1-2.2c38.5 26.4 152.9-44.8 84.5-84.4z"
                    class="cloud_folder_h"
                />
                <path
                    fill="#bbdefb"
                    d="M1593.9 2234.3c38.5 26.4 152.9-44.8 84.5-84.4l-96.4-55.6v134.1l14 8.1z"
                />
                <path
                    d="m1586 1878-8-1.1v207.9c2.7-.3 5.3-.5 8-.6zm-348.3-709.8a14 14 0 0 1-.9 2.9 6.1 6.1 0 0 1-3.1 3.2l198.7 114.7c3.7 2.2 7.5 4.5 11.2 6.9l7.3 5 7.2 5.3c58.1 44 105.2 116.9 117 181.5.2 1.3.5 2.6.7 3.9q.9 5.9 1.5 11.7c.5 5.1.7 10.2.7 15.2v283.7l8-.3v-283.4c0-5.2-.3-10.5-.8-15.9s-.9-8.1-1.6-12.2c-.2-1.4-.5-2.7-.7-4.1-6-32.8-20.6-67.9-42.1-101.3s-48.5-62.9-78-85.2l-7.4-5.4c-2.5-1.8-5-3.5-7.6-5.1s-7.7-4.9-11.5-7.1L1238 1167.7zM372.6 480.3 644 637l196.3 309.7a3.5 3.5 0 0 0 1.4 1.3l236.4 136.5c1.5-2.2 2.9-4.5 4.3-6.8L846.5 941.5 650.2 631.8a2.9 2.9 0 0 0-1.4-1.3L376.2 473.2zm1298.6 1740.2c-.3-1.4-.7-2.7-1-4.1a108.4 108.4 0 0 1-14.3 8.6c-23.5 12-47.5 14.3-59.7 5.9a3.9 3.9 0 0 0-2.3-.7h-.6L48.6 1338.5a3.7 3.7 0 0 0-2.4-3.3c-23.7-10.3-35.2-22.4-35.2-37V412.3c0-34 12.1-59.7 34-72.4 26.8-15.5 66.1-10.6 107.7 13.4l144.4 83.4c1.6-2.2 3.3-4.3 5-6.3l-145.4-84C112.6 320.9 70.4 316 41 333c-24.5 14.1-38 42.3-38 79.3v885.9c0 17.4 12.1 31.5 37 43a4 4 0 0 0 1.9 2.7l1552 896a3.9 3.9 0 0 0 2.8.4c5.4 2.4 11.8 3.5 18.9 3.5 13.1 0 28.5-4 43.8-11.8a126.9 126.9 0 0 0 14.2-8.5 3.9 3.9 0 0 1-2.4-3z"
                    class="cloud_folder_i"
                />
                <path
                    d="m308.2 443.2 1.2-1.8c.7-1.7 1.5-3.4 2.3-5.1l-.9.8a64.8 64.8 0 0 1-3.3 5.7z"
                    class="cloud_folder_i"
                />
                <path
                    d="m1898.2 1590.9-10.7 9.6a6.9 6.9 0 0 0-3.5 6.1v432c0 28.1-20 58-54.8 82a5.5 5.5 0 0 0-1.7 1.7l-157 91.1a9.6 9.6 0 0 0-2.8 1.1c-24.7 17.2-56 23.5-69.8 14a6.7 6.7 0 0 0-3.9-1.2L51.2 1336.6a6.7 6.7 0 0 0-3.8-4.1c-22.5-9.8-33.4-21-33.4-34.2v-886c0-32.9 11.5-57.7 32.5-69.8 25.9-14.9 64-10 104.7 13.4l161.3 93.2a6.8 6.8 0 0 0 7 0 7.1 7.1 0 0 0 3.5-6.1V243.3c0-32.9 11.5-57.7 32.5-69.8 25.9-14.9 64-10 104.7 13.4L685 316.8a7.3 7.3 0 0 0 6.6.2 6.7 6.7 0 0 0 3.8-5.4c.2-1.3.4-2.6.5-3.8-4.3-3.1-12.8-8.8-12.9-8.3L467.2 174.8c-45.1-26-88.3-30.9-118.7-13.4-25.5 14.7-39.5 43.8-39.5 81.9v187.6l-150.8-87.1c-45.1-26-88.3-30.9-118.7-13.4C14 345.1 0 374.2 0 412.3v885.9c0 18.5 12.3 33.3 37.6 45.2a7.4 7.4 0 0 0 2.9 3.2l1552 896a7.6 7.6 0 0 0 3.9 1 49 49 0 0 0 19.3 3.6c18.9 0 40.8-8.2 58.1-19.8l1.8-.7 162-94a6.5 6.5 0 0 0 2.6-2.6c36.9-26.3 57.9-59.4 57.9-91.4v-428a186.8 186.8 0 0 1 .1-19.8z"
                    class="cloud_folder_i"
                />
                <path
                    d="M1583.3 2105.8v-16l120.7 58s7.3 42.7 5.3 42.7-51.3 28-51.3 28z"
                    class="cloud_folder_b"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enable-background="new 0 0 2112.5 2257.6"
                viewBox="0 0 2112.5 2257.6"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <path
                    d="m1743.1 1126.6-590.6-341-196.9-310.5-492.2-284.2c-81.6-47.1-147.7-19.1-147.7 62.4v885.9c0 81.6-16.9 233.8 64.7 280.9l1291.3 810.4 162-94-.9-.2c33.9-23.3 57.9-55.1 57.9-87.7v-689.1c0-81.6-66.1-185.8-147.6-232.9z"
                    class="cloud_folder_st0"
                />
                <path
                    d="M713.1 335.1 463.4 190.9c-81.6-47.1-147.7-19.1-147.7 62.4v321.2h397.4V335.1z"
                    class="cloud_folder_st1"
                />
                <path
                    d="M2105.1 1357.6c0-156-97.9-343.1-227.9-447.9 9.1-21.9 14.2-48.3 14.2-78.9 0-133.7-95.7-297.4-213.5-365.7-44-25.5-84.9-33.9-118.5-27.7-61.6-157-176.7-304.6-308.5-380.9-107.2-62-203.2-64-268.3-17.1L799.2 145S681.4 335.2 681.4 493.4c0 200.5 143.3 446.3 320.5 548.7l822.1 609 202.5-115.9c48.5-30 78.6-91 78.6-177.6z"
                    class="cloud_folder_st2"
                />
                <linearGradient
                    id="cloud_folder_SVGID_1_"
                    x1="2005.721"
                    x2="1672.547"
                    y1="456.594"
                    y2="18.006"
                    gradientTransform="translate(-168.2 471.43)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset=".103" stop-color="#122E51" />
                    <stop offset=".27" stop-color="#2A4363" />
                    <stop offset=".482" stop-color="#526780" />
                    <stop offset=".729" stop-color="#8997A8" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    d="m1680.2 1022.7 197.4-114.9-.5-.5c9.1-21.9 14.2-48.3 14.2-78.9 0-133.7-95.7-297.4-213.5-365.7-44-25.5-84.9-33.9-118.5-27.9-.2-.2-.2-.7-.5-1L1361.6 549l318.6 473.7z"
                    class="cloud_folder_st3"
                />
                <linearGradient
                    id="cloud_folder_SVGID_00000129165677390796601860000015909008276200628110_"
                    x1="2207.684"
                    x2="1858.81"
                    y1="1041.673"
                    y2="582.419"
                    gradientTransform="translate(-168.2 471.43)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset=".103" stop-color="#122E51" />
                    <stop offset=".27" stop-color="#2A4363" />
                    <stop offset=".482" stop-color="#526780" />
                    <stop offset=".729" stop-color="#8997A8" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#cloud_folder_SVGID_00000129165677390796601860000015909008276200628110_)"
                    fill-rule="evenodd"
                    d="m1824 1648.5 202.5-115.9c48.6-29.8 78.6-90.9 78.6-177.4 0-155.8-97.6-342.6-227.5-447.5l-266.2 155.1 212.6 585.7z"
                    clip-rule="evenodd"
                />
                <linearGradient
                    id="cloud_folder_SVGID_00000068654715052001157050000008065313631220752290_"
                    x1="1563.712"
                    x2="1178.204"
                    y1="75.492"
                    y2="-431.988"
                    gradientTransform="translate(-168.2 471.43)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset=".103" stop-color="#122E51" />
                    <stop offset=".27" stop-color="#2A4363" />
                    <stop offset=".482" stop-color="#526780" />
                    <stop offset=".729" stop-color="#8997A8" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    fill="url(#cloud_folder_SVGID_00000068654715052001157050000008065313631220752290_)"
                    fill-rule="evenodd"
                    d="M1559 434.5c-61.6-157-176.5-304.4-308.2-380.6-107.2-62-203.2-64-268.3-17.1L799.2 142.4l429.2 477.3L1559 434.5z"
                    clip-rule="evenodd"
                />
                <path
                    d="M1677.8 1025.3c9.1-21.9 14.2-48.3 14.2-78.9 0-133.7-95.7-297.4-213.5-365.7-43.8-25.5-84.9-33.9-118.5-27.7-61.6-156.8-176.7-304.6-308.5-380.9C855 58.2 695.3 146.7 695.3 369.6c0 6.7.2 13.9.5 20.7-124.8-22.4-214 60.6-214 218.8 0 200.5 143.3 446.3 320.5 548.7l818.7 473.9c157.3 91.1 284.7 20.4 284.7-157.7-.4-156.8-98.3-343.6-227.9-448.7z"
                    class="cloud_folder_st6"
                />
                <path
                    d="M1205.6 300.6c.5-1.2 1.2-2.2 1.7-3.1-47.6-53.1-100-97.9-154.1-128.9-60.8-35.1-119.3-51.9-171.4-50.3 0 2.9-.2 5.8-.2 8.4 50.7-1.9 107.7 14.7 167.3 49.3 53.6 31 105.8 75.3 152.7 127.9.9-1.4 2.3-2.6 4-3.3zM1357 557.6l3.4-.5c34.1-6.3 74.1 3.1 115.7 27.2 27.4 16.3 52.5 36.1 74.8 58.9 1.2-2.7 3.6-4.6 6.5-5.3-22.8-23.5-48.7-43.9-76.9-60.6-41.8-24.3-82.5-34.1-117.8-28.9-15.5-38.8-33.9-76.4-55.1-112.5-1.8 2.2-4.2 3.8-7 4.6 21.3 36.7 39.9 74.8 55.5 114.2l.9 2.9zM1877.6 1587.7c1.5.4 3 1.1 4.3 1.9 1.3.1 2.5.5 3.6 1.2 15.9-32 24-71.7 24-117.1 0-153.4-95.2-341.7-227-449.4 8.7-22.4 13.2-48.3 13.2-77.7 0-47.6-12.3-99.1-32.7-148.6-2.6 1.2-5.3 1.9-8.2 1.9 20.7 48.8 32.5 99.5 32.5 146.4 0 29.3-4.8 55.5-13.9 77.4l-1.2 2.9 2.6 1.9c131.3 105.8 226.3 293.1 226.3 444.8.1 44.7-8.1 83.4-23.5 114.4z"
                    class="cloud_folder_st7"
                />
                <path
                    d="M2105.1 1357.6c0-156-97.9-343.1-227.9-447.9 9.1-21.9 14.2-48.3 14.2-78.9 0-133.7-95.7-297.4-213.5-365.7-44-25.5-84.9-33.9-118.5-27.7-61.6-157-176.7-304.6-308.5-380.9-107.2-62-203.2-64-268.3-17.1L801.1 143.8c-65.4 35.3-105.8 113.5-105.8 225.8 0 6.7.2 13.9.5 20.7-124.8-22.4-214 60.6-214 218.8 0 200.5 143.3 446.3 320.5 548.7l818.7 473.9c87.8 50.7 165.9 51.2 218.1 11.1l187.5-107.5c48.4-30.1 78.5-91.1 78.5-177.7z"
                    class="cloud_folder_st8"
                />
                <path
                    d="m1588.7 2138.5-7.3-24 .3-586c0-5.1-.3-10.3-.8-15.5-.4-3.9-.9-7.9-1.5-11.9-.2-1.3-.4-2.7-.7-4-12-65.8-59.1-139.1-118.5-184-2.4-1.8-4.9-3.6-7.3-5.4s-4.9-3.4-7.4-5.1c-3.7-2.4-7.5-4.8-11.4-7l-590.6-341-196.9-310.5-492.2-284.2C72.8 312.8 6.7 340.8 6.7 422.3v885.9c0 17.5 14.3 30.5 37.6 40.7l-.6 1.6 1552 896s-.8-.7-2.1-2.2c38.5 26.4 63.5-66.2-4.9-105.8z"
                    class="cloud_folder_st6"
                />
                <path
                    d="M1593.6 2244.3c38.5 26.4 152.9-44.8 84.5-84.4l-96.4-55.6v134.1l14 8.1s-.8-.7-2.1-2.2z"
                    class="cloud_folder_st0"
                />
                <path
                    d="M1237.4 1178.2c-.2 1-.5 2-.9 2.9-.7 1.7-1.9 2.7-3.1 3.2l198.7 114.7c3.7 2.2 7.5 4.5 11.2 6.9 2.4 1.6 4.9 3.3 7.3 5s4.8 3.5 7.2 5.3c58.1 44 105.2 116.9 117 181.5.2 1.3.5 2.6.7 3.9.6 3.9 1.1 7.8 1.5 11.7.5 5.1.7 10.2.7 15.2v283.7c2.7-.1 5.3-.2 8-.3v-283.4c0-5.2-.3-10.5-.8-15.9-.4-4-.9-8.1-1.6-12.2-.2-1.4-.5-2.7-.7-4.1-6-32.8-20.6-67.9-42.1-101.3-21.5-33.4-48.5-62.9-78-85.2-2.5-1.9-5-3.7-7.4-5.4-2.5-1.8-5-3.5-7.6-5.1-3.8-2.5-7.7-4.9-11.5-7.1l-198.3-114.5c0 .1-.2.3-.3.5zM372.3 490.3 643.7 647 840 956.7c.3.5.8 1 1.4 1.3l236.4 136.5c1.5-2.2 2.9-4.5 4.3-6.8L846.2 951.5 649.9 641.8c-.3-.5-.8-1-1.4-1.3L375.9 483.2c-1.2 2.3-2.4 4.7-3.6 7.1z"
                    class="cloud_folder_st7"
                />
                <path
                    d="m1897.9 1600.9-10.7 9.6c-2.2 1.2-3.5 3.6-3.5 6.1v432c0 28.1-20 58-54.8 82-.7.5-1.3 1.1-1.7 1.7l-157 91.1c-1 .2-1.9.6-2.8 1.1-24.7 17.2-56 23.5-69.8 14-1.2-.8-2.5-1.2-3.9-1.2L50.9 1346.6c-.6-1.8-2-3.3-3.8-4.1-22.5-9.8-33.4-21-33.4-34.2v-886c0-32.9 11.5-57.7 32.5-69.8 25.9-14.9 64-10 104.7 13.4l161.3 93.2c2.2 1.3 4.8 1.3 7 0s3.5-3.6 3.5-6.1V253.3c0-32.9 11.5-57.7 32.5-69.8 25.9-14.9 64-10 104.7 13.4l224.8 129.9c2 1.2 4.5 1.2 6.6.2s3.5-3 3.8-5.4c.2-1.3.4-2.6.5-3.8-4.3-3.1-12.8-8.8-12.9-8.3L466.9 184.8c-45.1-26-88.3-30.9-118.7-13.4-25.5 14.7-39.5 43.8-39.5 81.9v187.6l-150.8-87.1c-45.1-26-88.3-30.9-118.7-13.4C13.7 355.1-.3 384.2-.3 422.3v885.9c0 18.5 12.3 33.3 37.6 45.2.6 1.3 1.6 2.4 2.9 3.2l1552 896c1.2.7 2.5 1 3.9 1 5.8 2.5 12.4 3.6 19.3 3.6 18.9 0 40.8-8.2 58.1-19.8.6-.2 1.2-.4 1.8-.7l162-94c1.1-.6 2-1.5 2.6-2.6 36.9-26.3 57.9-59.4 57.9-91.4v-428c-.1-.1-.5-14 .1-19.8z"
                    class="cloud_folder_st2"
                />
            </svg>
        );
    }
}
